<template>
    <config-section
        :title="$t('auth.language_preferences')"
        :description="$t('auth.personal_preferences_description')"
    >

        <div v-if="fetchingLanguages && fetchingCommunicationLanguages">
            <loading></loading>
        </div>
        <div v-else>
            <template>
                <select-dropdown
                    v-model="form.language"
                    :options="availableLanguages"
                >
                    {{ $t('general.your_language') }}
                </select-dropdown>
            </template>

            <template>
                <select-dropdown
                    v-model="form.communication_language"
                    :options="communicationLanguages"
                    class="mt-16"
                >
                    {{ $t('general.your_communication_language') }}
                </select-dropdown>
            </template>
        </div>



        <template #buttons>
            <simple-button
                :disabled="!form.isDirty()"
                display="secondary"
                icon="save"
                :loading="form.submitting"
                look="primary"
                @click="saveProfile"
            >{{ $t('general.save') }}
            </simple-button>
        </template>

    </config-section>
</template>

<script>
import {mapState, mapActions} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../state/store';
import {useAuthenticationStore} from '../state/modules/authentication';
import Form from '../etc/forms/Form';
import SimpleButton from './ui/SimpleButton.vue';
import SelectDropdown from './forms/SelectDropdown.vue';
import * as users from '../services/UserService';
import * as languages from '../services/LanguageService';
import User from '../models/User';
import { normalizeJson } from '../../shared/helpers';
import ConfigurationSection from './ConfigurationSection.vue';
import Loading from "./ui/Loading.vue";

export default {
    components: {
        Loading,
        'config-section': ConfigurationSection,
        'simple-button': SimpleButton,
        'select-dropdown': SelectDropdown,
    },
    setup() {
        const mainStore = useMainStore();
        return {mainStore};
    },
    data: function () {
        return {
            form: this.generateForm(),
            fetchingLanguages: true,
            fetchingCommunicationLanguages: true,

            communicationLanguages: null
        }
    },
    computed: {
        ...mapState(useMainStore, ['availableLanguages']),
        ...mapState(useAuthenticationStore, ['currentUser']),
    },
    methods: {
        ...mapActions(useMainStore, ['setLocale', 'setInterfaceLanguages']),
        generateForm() {
            let user = this.mainStore.currentUser;

            return new Form([
                {name: 'language', value: user.language, rules: ['required']},
                {name: 'communication_language', value: user.communication_language, rules: ['required']}
            ])
        },
        saveProfile() {
            return this.form.submit(data => users.update(this.currentUser.id, {
                data: {attributes: data}
            })).then(result => {
                return useRepo(User).save(normalizeJson(result));
            }).then(user => {
                this.setLocale(user.language);
                this.$i18n.locale = user.language;
            })
        }
    },
    mounted() {
        languages.interfaceLanguages().then((data) => {
            this.setInterfaceLanguages(data);
            this.fetchingLanguages = false;
        });
        languages.communicationLanguages().then((data) => {
            this.communicationLanguages = data;
            this.fetchingCommunicationLanguages = false;
        });
    }
}
</script>
